module.exports = __webpack_public_path__ + "img/vip-logo.8b9d7d65.svg";